export default __webpack_public_path__ + "static/media/Copper_Mar21_Rank.a0056c8e.png";